export const DefaultThemesV2 = {
  fontSize: {
    XSmallMobileFontSize: '0.570em',
    SmallMobileFontSize: '0.645em',
    DefaultFonts: '0.715em',
    SmallerFontSize: '0.785em',
    SmallFontSize: '0.8125em',
    MediumFontSize: '0.8570em',
    PrimaryFontSize: '0.9285em',
    DefaultFontSize: '1em',
    LargeFontSize: '1.070em',
    LargerFontSize: '1.145em',
    HeadingH5FontSize: '1.215em',
    HeadingH4FontSize: '1.285em',
    HeadingH3FontSize: '1.360em',
    HeadingH2FontSize: '1.430em',
    HeadingH1FontSize: '1.570em',
    XLargeFontSize: '1.715em',
  },
  fontFamily: {
    MontserratSemiBold: 'MontserratSemiBold',
  },
  borderRadius: {
    borderbtn: '0.325em',
    borderBlock: '0.6em',
  },
  colorStyled: {
    Action: '#4786FC',
    ColorWhite: '#ffffff',
    ColorBlack: '#000000',
    ColorNavBar: '#FF9E16',
    ColorBgDefault: '#ff9e16',
    ColorBgDefaultHover: '#d67f04',
    ColorBgDefaultShadow: '#ff9e1630',
    ColorBgDefaultMuted: '#ff9e1699',
    ColorBgSilver: '#f4f5f7',
    ColorBgHover: '#ffe2ba',
    ColorBgContent: '#f6f7fb',
    ColorHint: '#CCCCCC',
    ColorPrimary: '#2b1a08',
    ColorSecond: '#a7a7a7',
    ColorDark: '#1b1b1b',
    ColorLighterGrey: '#767676',
    ColorDarkerGrey: '#666666',
    ColorGrey: '#6e7079',
    ColorYellowCheckbox: '#ffc700',
    ColorRedDel: '#d72111',
    ColorLightGrey: '#bdb8b6',
    ColorBtn: '#f5f5f5',
    ColorBtnHover: '#eaeaea',
    ColorBtnDark: '#e2e2e2',
    ColorBorder: '#e7e7e7',
    ColorBorderInput: '#091e4214',
    ColorHeaderTable: '#585754',
    ColorBgLeft: '#f4f5f7',

    ColorPrimaryGreen: '#1bd18a',
    ColorPrimaryBlue: '#2E5BC7',
    ColorPrimaryBlueHover: '#1d4aa0',
    ColorBgMyCourses: '#fbfbfb',
    ColorBgSideBarDefault: '#f9f9f9',
    ColorDefault: '#6f6f6f',
    ColorSuccess: '#1bd18a',
    ColorSuccessN: '#37921e',
    ColorDarkGrey: '#020b0d',
    ColorMidGrey: '#e8e8e8',
    ColorTime: '#767676',

    ColorXBorder: '#e0dedb',
    ColorPoint: '#a5a5a5',
    ColorBorderClassNav: '#edeff1',

    ColorXLightGrey: '#1e2328',
    ColorXXLightGrey: '#2a2f34',
    ColorXXXLightGrey: '#0c0d12',
    ColorLink: '#433aef',
    ColorActiveCheckbox: '#18c798',
    ColorLevelKill: '#8c9093',
    ColorLevelKillActive: '#1787e2',
    ColorBgClassNav: '#f7f9fa',
    ColorBoxShadow: '#dbdbdb',
    ColorSilver: '#a4a4a4',
    ColorWarming: '#5160ef',
    ColorPurple: '#6669C9',
    ColorBgForm: '#ececec',
    ColorSkipped: '#bdbdbd',
    ColorMing: '#385e7e',
    ColorPeach: '#fee2b4',
    ColorBgAvartar: '#d2d2d2',
    ColorUser: '#1a1a1a',
    ColorWarning: '#C62828',

    ColorBorderSilver: '#cbcbcb',
    ColorBorderPractice: '#dedede',
    ColorBorderHampton: '#e3d0ad',
    ColorSilverChalice: '#9e9e9e',
    ColorBgSeashell: '#f7f7f7',
    ColorAlto: '#d6d6d6',
    ColorHint: '#d9d9d9',
    ColorAlizarinCrimson: '#D92222',
    ColorFunGreen: '#01a41c',
    ColorDoveGray: '#6e6e6e',

    ColorGreenPoint: '#34DF9D',
    ColorRedPoint: '#ba0c28',
    ColorSelectedScoreSeperate: 'rgba(163,173,186,0.2)',
    ColorSectionDashboard: '#767C84',
    ColorTopicUpIcon: '#415063',
    ColorTableHeader: '#0c0d12',
    ColorScoreStep: '#0f1013',
    ColorLightCoral: '#ff7f7f',
    ColorLightOrange: '#fff2e3',
    ColorOrange: '#ff9e16',
    ColorLightRedGray: '#f2eceb',
    ColorRedGray: '#453635',
    ColorLightYellow: '#fff9e3',
    ColorYellow: '#ffce2a',
    ColorMidBlue: '#528ffd',

    ColorSkilLevelOne: '#d11010',
    ColorSkilLevelTwo: '#69cc27',
    ColorQuiteBlue: '#4A86E8',
  },
};
